import { Controller } from "@hotwired/stimulus";

// Toggles every country in a group that is present in the filter's current options:
export default class extends Controller {
  select(event) {
    const values = new Set(JSON.parse(event.currentTarget.dataset.countryGroupValues))
    const list = this.element.closest("details").querySelector(".filter-list")
    const boxes = Array.from(list.querySelectorAll('input[type="checkbox"]'))
      .filter((box) => values.has(box.value) && !box.disabled)
    if (boxes.length === 0) { return }

    const checking = boxes.some((box) => !box.checked)
    boxes.forEach((box) => { box.checked = checking })
    boxes[boxes.length - 1].dispatchEvent(new Event("change", { bubbles: true }))
  }
}
